/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { QueryClient } from 'react-query';
import { useUpdateTagMutation } from 'src/graphql';
import { TRootState } from 'src/store';

type UpdateTagArgs = {
  tagTypeId: string;
  tagId: string;
  status: string;
  name: string;
  mutationUpdateTag: ReturnType<typeof useUpdateTagMutation>['mutateAsync'];
  queryClient: QueryClient;
  setDuplicateTagName?: (value: boolean) => void;
};

export const updateTagAction = createAsyncThunk<
  void,
  UpdateTagArgs,
  { state: TRootState }
>(
  'tagType/tagUpdated',
  async ({
    tagId,
    name,
    status,
    tagTypeId,
    mutationUpdateTag,
    queryClient,
    setDuplicateTagName,
  }: UpdateTagArgs) => {
    try {
      await mutationUpdateTag({
        parameters: {
          name,
          status,
          tagId,
          type: tagTypeId,
        },
      });
      queryClient.invalidateQueries('getOrganisationTagTypes');
      queryClient.invalidateQueries('getOrganisationTags');
    } catch (error) {
      if (
        (error as Error).message === 'Tag with this name already exists' &&
        setDuplicateTagName
      ) {
        setDuplicateTagName(true);
      }
      throw error;
    }
  },
);
